import { lazy, Suspense } from "react";
import { Navigate, Route, RouteProps, Routes } from "react-router-dom";

import { RouteFallback } from "components/atoms/route-fallback/RouteFallback";
// Step 1 is the initial route (/ redirects here), so it stays in the main
// bundle to keep the first render on the critical path — no extra chunk fetch
// or fallback flash on load. Steps 2–7 are code-split into their own chunks so
// their code (notably step 3's MUI date pickers and step 6's Stripe wrapper)
// leaves the initial boot task and only loads when the user reaches that step.
import Step1 from "pages/step-1";

// webpackPrefetch downloads each step chunk during browser idle time after the
// initial load (as a low-priority <link rel="prefetch">), NOT during the boot
// task — so TBT stays low, but by the time the user finishes the current step's
// form the next chunk is already cached and navigation is instant. Prefetched
// chunks are fetched, not parsed/executed, until the step actually renders.
const Step2 = lazy(() => import(/* webpackPrefetch: true */ "pages/step-2"));
const Step3 = lazy(() => import(/* webpackPrefetch: true */ "pages/step-3"));
const Step4 = lazy(() => import(/* webpackPrefetch: true */ "pages/step-4"));
const Step5 = lazy(() => import(/* webpackPrefetch: true */ "pages/step-5"));
const Step6 = lazy(() => import(/* webpackPrefetch: true */ "pages/step-6"));
const Step7 = lazy(() => import(/* webpackPrefetch: true */ "pages/step-7"));

const routes: RouteProps[] = [
  {
    path: ":optionalParam?step-1",
    element: <Step1 />,
  },
  {
    path: ":optionalParam?step-2",
    element: <Step2 />,
  },
  {
    path: ":optionalParam?step-3",
    element: <Step3 />,
  },
  {
    path: ":optionalParam?step-4",
    element: <Step4 />,
  },
  {
    path: ":optionalParam?step-5",
    element: <Step5 />,
  },
  {
    path: ":optionalParam?step-6",
    element: <Step6 />,
  },
  {
    path: ":optionalParam?step-7",
    element: <Step7 />,
  },
];

const AppRouter = () => {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        {routes.map((route) => (
          <Route key={route.path} {...route} />
        ))}
        <Route path="/" element={<Navigate to="step-1" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
